import {AfterViewInit, ChangeDetectorRef, Component, HostBinding, Input, OnInit, ViewChild} from '@angular/core';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import {GnFormUtils, GnValidatorMessage} from 'geminis-ng-core';
import {GnFormDirective} from '../form.directive';
import {NzFormControlComponent, NzFormDirective} from 'ng-zorro-antd/form';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'gn-form-item,[gn-form-item]',
  templateUrl: './form-item.component.html',
  styleUrls: ['./form-item.component.css']
})
export class GnFormItemComponent implements OnInit, AfterViewInit {

  private colspanValue: number;

  formControl: FormControl;
  labelWidth: number;
  controlWidth: number;
  controlVisible = true;

  @ViewChild(NzFormControlComponent) nzFormControl: NzFormControlComponent;

  @Input() set visible(value: boolean) {
    this.controlVisible = value;
    this.ensureFormControl();
  }

  get visible(): boolean {
    return this.controlVisible;
  }

  @Input() label: string;
  @Input() field: string;

  @Input() set colspan(value: number) {
    this.colspanValue = value;
    if (this.colspanValue > 1 && this.label) {
      this.labelWidth = Math.ceil(this.gnForm.labelWidth / this.colspanValue);
      this.controlWidth = Math.floor((this.gnForm.controlWidth + (this.colspanValue - 1) * 24) / this.colspanValue);
    } else if (!this.label) {
      this.controlWidth = 24;
    }
  }

  get colspan(): number {
    return this.colspanValue;
  }

  @Input() rowspan: number;
  @Input() validators: GnValidatorMessage[] = [];
  @Input() defaultValue: any;
  @Input() display?: boolean;

  get hasRequired(): boolean {
    return this.validators && this.validators.some((validator) => validator.validator === 'required');
  }

  @HostBinding('style.grid-column') get colSpan(): SafeStyle {
    return this.colspan ?
      this.domSanitizer.bypassSecurityTrustStyle('auto / span ' + this.colspan) :
      null;
  }

  @HostBinding('style.grid-row') get rowSpan(): SafeStyle {
    return this.colspan ?
      this.domSanitizer.bypassSecurityTrustStyle('auto / span ' + this.rowspan) :
      null;
  }

  @HostBinding('style.display') get styleDisplay(): SafeStyle {
    return this.display === false ? 'none' : '';
  }

  constructor(public gnForm: GnFormDirective,
              public nzForm: NzFormDirective,
              private cdr: ChangeDetectorRef,
              private domSanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.ensureFormControl();
  }

  ngAfterViewInit(): void {
    // this.ensureFormControl();
    if (this.nzFormControl) {
      this.nzFormControl.nzValidateStatus = this.formControl;
    }

    if (this.defaultValue || this.defaultValue === false) {
      if (typeof this.defaultValue === 'string' && this.defaultValue.startsWith('{') && this.defaultValue.endsWith('}')) {
        // tslint:disable-next-line:no-eval
        const calcValue = eval(this.defaultValue.substr(1, this.defaultValue.length - 2));
        this.formControl.patchValue(calcValue);
      } else {
        this.formControl.patchValue(this.defaultValue);
      }
      this.cdr.detectChanges();
    }
  }

  private ensureFormControl(): void {
    if (this.field) {
      if (this.controlVisible) {
        this.formControl = GnFormUtils.ensureFormControl(this.gnForm.formGroup, this.field, this.validators);
      } else {
        GnFormUtils.removeFormControl(this.gnForm.formGroup, this.field);
      }
    }
  }
}


